import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Users, Zap, Cloud } from 'lucide-react';
import './Solutions.css';

const solutionsData = [
    {
        number: "01",
        icon: <Globe size={28} strokeWidth={1.5} />,
        problem: "Establish your digital presence",
        solution: "We build modern websites and apps that turn your online presence into a real business asset — fast, reliable, and built to convert.",
        tag: "Web & Mobile"
    },
    {
        number: "02",
        icon: <Users size={28} strokeWidth={1.5} />,
        problem: "Manage your workforce effectively",
        solution: "We build systems that simplify employee records, attendance, leave, payroll, performance, and reporting — all in one place.",
        tag: "Business Systems"
    },
    {
        number: "03",
        icon: <Zap size={28} strokeWidth={1.5} />,
        problem: "Automate repetitive processes",
        solution: "We design intelligent automation solutions that eliminate manual work, reduce errors, and free your team to focus on what matters.",
        tag: "AI & Automation"
    },
    {
        number: "04",
        icon: <Cloud size={28} strokeWidth={1.5} />,
        problem: "Scale your infrastructure",
        solution: "We engineer cloud-ready systems with the reliability, security, and scalability your growing organization demands.",
        tag: "Cloud & DevOps"
    }
];

const Solutions = () => {
    return (
        <section id="solutions" className="solutions-section">
            <div className="container">

                {/* Header */}
                <motion.div
                    className="solutions-header"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                >
                    <span className="solutions-eyebrow">Our Solutions</span>
                    <h2 className="solutions-title">
                        Technology built around <br />
                        <span className="text-gradient">your business challenges.</span>
                    </h2>
                    <p className="solutions-subtitle">
                        Whatever challenge your business faces, we engineer a solution built for it.
                    </p>
                </motion.div>

                {/* Cards Grid */}
                <div className="solutions-grid">
                    {solutionsData.map((item, index) => (
                        <motion.div
                            key={index}
                            className="solution-card"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            {/* Top row: number + icon */}
                            <div className="solution-card-top">
                                <span className="solution-number">{item.number}</span>
                                <div className="solution-icon">{item.icon}</div>
                            </div>

                            {/* Tag */}
                            <span className="solution-tag">{item.tag}</span>

                            {/* Problem statement */}
                            <h3 className="solution-problem">{item.problem}</h3>

                            {/* Answer */}
                            <p className="solution-answer">{item.solution}</p>

                            {/* Hover accent line */}
                            <div className="solution-accent-line" />
                        </motion.div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default Solutions;
